import { useSystemStore } from "@dealer-center/ddc-state-system";
import type { LDReactOptions } from "launchdarkly-react-client-sdk";
import { LDProvider } from "launchdarkly-react-client-sdk";
import type { LDContext } from "launchdarkly-js-client-sdk";
import { getActiveFlags } from "@dealer-center/core-interfaces-third-party-launch-darkly";
import { useGetUser } from "@dealer-center/ddc-api-user-fetch";
import { getAccountIdFromPath } from "../utils/utils";
import { useGetAccount } from "@dealer-center/ddc-api-account-fetch";

const reactOptions: LDReactOptions = {
  useCamelCaseFlagKeys: false
};

const flags = getActiveFlags("cc9");
export const LaunchDarkly = ({ children }: { children: React.ReactNode }) => {
  const { data: userEntity } = useGetUser();
  const { config } = useSystemStore();
  const { data: accountEntity } = useGetAccount();
  if (!config.launchDarklyKey || !userEntity?.sessionId) {
    // eslint-disable-next-line react/jsx-no-useless-fragment
    return <>{children}</>;
  }
  const getLDContext = () => {
    const accountId = getAccountIdFromPath() || accountEntity?.id;
    if (accountId) {
      return {
        kind: "multi",
        user: {
          key: userEntity.user ?? "",
          name: userEntity.first + " " + userEntity.last,
          isInternal: userEntity.internal
        },
        account: {
          key: accountId ?? "",
          name: accountId ?? "",
          id: accountId
        }
      };
    } else {
      return {
        kind: "user",
        key: userEntity.user ?? "",
        name: userEntity.first + " " + userEntity.last,
        isInternal: userEntity.internal
      };
    }
  };
  const context: LDContext = getLDContext() as LDContext;
  return (
    <LDProvider
      {...{
        clientSideID: config.launchDarklyKey,
        flags,
        reactOptions,
        context
      }}
    >
      {children}
    </LDProvider>
  );
};
